import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export const ScrollToTopButton = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 300);
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <button
            onClick={() =>
                window.scrollTo({ top: 0, behavior: "smooth" })
            }
            className={`fixed bottom-6 right-6 p-3 rounded-full shadow-lg transition-all duration-300 hover:bg-[#0041A3]
                        ${visible ? "opacity-100 translate-y-0 bg-[#0056D2] text-white" : "opacity-0 translate-y-4 pointer-events-none"}
                    `}
        >
            <ArrowUp size={20} />
        </button>
    );
};